
export const environment = {
  production: true,
  releaseStage: 'production',
  appName: 'Paramount Insight',
  version: '4.0.1',
  apiUrl: 'https://insight.paramount-land.com/api',
  wsUrl: 'wss://insight.paramount-land.com/ws',
  authUrl: 'https://account.paramount-land.com/signin',
  authCallbackUrl: 'https://insight.paramount-land.com/auth',
  authTokenUrl: 'https://account.paramount-land.com/v3/token',
  authRefreshTokenUrl: 'https://account.paramount-land.com/v3/refresh-token',
  authMenuUrl: 'https://account.paramount-land.com/api/v2/authorization/menu-token',
  apiKey: 'b63b118f-bf8d-49c2-a342-5b808c7be667',
};
